import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ZonaExtendidaCPList } from "./cps";

type Entity = models.ZonaExtendida;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un ZonaExtendida
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Nombre: validation.required,
        IdSucursal: validation.required,
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class ZonaExtendidaFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelector(this.value, x => validar(x));
    hasError = createSelector(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);

        const Precio = getField(selectores.TarifaZEPrecio);
        const Sucursal = getField(selectores.Sucursal);

        const CPs = getField(ZonaExtendidaCPList);

        return (
            <div>
                <kea.Title titulo="Zona extendida" onRegresar={() => history.go("../")} />
                {kea.autogrid(3, [
                    <Text field="Nombre" label="Nombre" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <Precio field="IdTarifaPrecio" label="Tarifa de precio"/>,
                    <Number field="TiempoEntrega" label="Tiempo de entrega (días)" />,
                ])}

                {kea.autogrid(6, [
                    <CPs field="CPs" />,
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const ZonaExtendidaForm = componentToRx(ZonaExtendidaFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/zonaextendida/edit/form.tsx